module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-430deb4668cf678d19d32553381dc0ba.png";